export const TOOL_OPTIONS = [
  "getUserDetails",
  "updateUserProfile",
  "authenticateUser",
  "getAccountBalance",
  "getTransactionHistory",
  "getTransactionDetails",
  "initiateTransfer",
  "scheduleRecurringPayment",
  "fetchExchangeRates",
  "calculateLoanEligibility",
  "createDisputeTicket",
  "checkFraudAlerts",
  "updateCommunicationPreferences",
  "escalateSupportCase",
] as const;

export type ToolOption = (typeof TOOL_OPTIONS)[number];
